import consts from "../consts";

function AuthService2(config) {
	let serverUrl = config.serverUrl;
	if (serverUrl[serverUrl.length - 1] !== "/") {
		serverUrl += "/";
	}

	let _token = null;
	// let _expTime = null;

	const api = {
		loginToolbar(username, password) {
			return fetch(serverUrl + "agentToolBarLogin", {
				method: "POST",
				body: JSON.stringify({username, password}),
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(response => response.json())
				.then(response => {
					let isValid = false;
					if (response.status === "ok" || !!response.token) {
						isValid = true;
						api.setToken(response, "agent-toolbar");
					}
					return {response, valid: isValid};
				});
		},
		setToken(response, type = "app") {
			const {token} = response;
			_token = token;
			localStorage.token = token;
			// temp code
			if (type === "agent-toolbar") {
				localStorage.setItem("tokenExpire", response.expireTime * 1000);
				localStorage.setItem("logo", response.logo || "");
				localStorage.setItem("userType", consts.PRODUCT.TOOLBAR);
				// localStorage.setItem('userName', $scope.userName);
				window.LSM.handleLogin();
			}
		},
		getToken() {
			return _token;
		},
		logout() {
			_token = null;
			// _expTime = null;
			localStorage.clear();
		},
		loadFromBrowser() {
			_token = localStorage.token;
		}
	};

	return api;
}

const authServiceInstance = null;

export async function getAuthService() {
	if (authServiceInstance) {
		return authServiceInstance;
	}

	let config = await window.LSM.systemConfigPromise;
	return AuthService2(config);
}
